import React from 'react';
import { MUIDataTableColumnDef, MUIDataTableMeta } from 'mui-datatables';
import { RenderStatus } from '../RenderStatus';
import { SupplierCounter } from '../SupplierCounter';
import { EditButton } from '../EditButton';
import { InjectedRouter } from 'react-router';
import { ViewFormButton } from '../ViewFormButton';
import { AnswerFormButton } from '../AnswerFormButton';
import { DeleteButton } from '../DeleteButton';
import { ExportButton } from '../ExportButton';

type Props = {
  router: InjectedRouter;
  isVisaoTok?: boolean;
  currentSupplierId?: number;
};

export const tableHeaders = ({ router, isVisaoTok = false, currentSupplierId }: Props) => {
  const isSupplierVision = isVisaoTok && !currentSupplierId;
  const columns = [
    { name: 'idForm', label: 'ID Formulário' },
    {
      name: 'deleteBtn',
      label: 'Cancelar',
      options: {
        setCellProps: () => ({ style: { justifyItems: 'center' } }),
        customBodyRender: (value: string, metadata: MUIDataTableMeta) => <DeleteButton rowIndex={metadata.rowIndex} />
      }
    },
    { name: 'nmForm', label: 'Nome Formulário' },
    {
      name: 'status',
      label: 'Status',
      options: {
        display: true,
        customBodyRender: (value: string, metadata: MUIDataTableMeta) => <RenderStatus rowIndex={metadata.rowIndex} />
      }
    },
    { name: 'dtInicioVig', label: 'Data Ínicio' },
    { name: 'dtFimVig', label: 'Data Final' },
    {
      name: 'viewFormBtn',
      label: 'Visualizar Formulário',
      options: {
        setCellProps: () => ({ style: { justifyItems: 'center' } }),
        customBodyRender: (value: string, metadata: MUIDataTableMeta) => (
          <ViewFormButton rowIndex={metadata.rowIndex} router={router} />
        )
      }
    },
    {
      name: 'editFormBtn',
      label: 'Editar Formulário',
      options: {
        setCellProps: () => ({ style: { justifyItems: 'center' } }),
        customBodyRender: (value: string, metadata: MUIDataTableMeta) => (
          <EditButton rowIndex={metadata.rowIndex} router={router} />
        )
      }
    },
    {
      name: 'fillFormBtn',
      label: 'Responder Formulário',
      options: {
        setCellProps: () => ({ style: { justifyItems: 'center' } }),
        customBodyRender: (value: string, metadata: MUIDataTableMeta) => (
          <AnswerFormButton rowIndex={metadata.rowIndex} router={router} />
        )
      }
    },
    {
      name: 'export',
      label: 'Exportar',
      options: {
        setCellProps: () => ({ style: { justifyItems: 'center' } }),
        customBodyRender: (value: string, metadata: MUIDataTableMeta) => <ExportButton rowIndex={metadata.rowIndex} />
      }
    },
    {
      name: 'filled',
      label: 'Preenchimento',
      options: {
        customBodyRender: (value: string, metadata: MUIDataTableMeta) => (
          <SupplierCounter rowIndex={metadata.rowIndex} />
        )
      }
    }
  ] as MUIDataTableColumnDef[];

  const supplierAvoidColumns = ['filled', 'editFormBtn', 'deleteBtn', 'export'];
  const tokAvoidColumns = ['fillFormBtn'];

  return columns.filter((col) => {
    const columnName = typeof col === 'string' ? col : col.name;

    if (isSupplierVision) {
      return !tokAvoidColumns.includes(columnName);
    }

    return !supplierAvoidColumns.includes(columnName);
  });
};
